import {gql} from "@apollo/client";

export const WALLET_UPDATED = gql`
          subscription WalletUpdated($walletId: String) {
            walletUpdated(walletId: $walletId) {
              id,
              currency,
              balance
            }
  }
`;
